export const recievedAudio =
 typeof Audio !== 'undefined' ? new Audio('/audio/recieved_message.mp3') : null
export const SendAudio =
 typeof Audio !== 'undefined' ? new Audio('/audio/sent_message.mp3') : null

const useChatAlertSound = (): {
 playSendAudio?: () => void
 playRecieved?: () => void
} => ({
 playRecieved: () => recievedAudio?.play(),
 playSendAudio: () => SendAudio?.play(),
})

export default useChatAlertSound
